import React from "react";
import BobbyService from "../data/bobby_service";

const contactMethod = BobbyService.getContactInfo().find(x => x.type === "type");

const Footer = () => {
  return (
    <footer className="cp_global-footer">
      <div className="container">
        <div className="flex-container space-between">
          <div><a href={"mailto:" + contactMethod.emailUrl}>{contactMethod.email}</a>
            <a target="_blank" rel="noopener noreferrer" href={contactMethod.linkedUrl}>{contactMethod.linked}</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
export default Footer;